enum Mutations {
  SET_SEARCH_QUERY = 'setSearchQuery',
  SET_EMPLOYMENTS = 'setEmployments',
  UPDATE_EMPLOYMENTS = 'updateEmployments',
}

export default Mutations;
